import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import { bindActionCreators } from 'redux';
import { withRouterV6 } from '../../../helpers/withRouterV6.jsx';
import { capitalizeCamelCase } from '../../../helpers/stringUtils';
import NavigationStateManager from '../../../helpers/NavigationStateManager';

import * as accountSettingsActions from './reducer';

import VerticalMenu from './menu';
import AccountDetails from './detail';
import UpdatePassword from './updatePassword';
import EyesOnly from './eyesOnly';
import Security from './security';
import BasePageView from '../../../components/common/basePageView';
import { withPageTitle } from '../../../hocs/withPageTitle';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';

import { Record } from '../../../modules/bin/utility';
import clear from '../../../components/clear';
import get from 'lodash.get';

import { settingsMenuItems, i18nKeys } from '../constants';


import EmailNotifications from './emailNotifications';

class AccountSettingsPage extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.props.getRecord(this.props.match.params.id);
    }
    
    // Update URL when active tab changes (only if URL doesn't already have a tab)
    if (this.props.activeItem !== prevProps.activeItem) {
      const currentTab = this.props.match.params.tab;
      const newTab = this.props.activeItem;
      if (!currentTab && newTab) {
        // No tab in URL but we have an active tab - add it to URL
        this.props.history.replace(`/accounts/settings/${this.props.match.params.id}/${newTab}`);
      } else if (currentTab && currentTab !== newTab) {
        // Tab in URL is different from active tab - update it
        this.props.history.replace(`/accounts/settings/${this.props.match.params.id}/${newTab}`);
      }
    }
  }

  componentDidMount() {
    this.props.getRecord(this.props.match.params.id);
    
    // Set active item from URL tab parameter or default to first tab
    const urlTab = this.props.match.params.tab;
    if (urlTab && urlTab !== this.props.activeItem) {
      this.props.menuItemClick(urlTab);
    } else if (!urlTab && !this.props.activeItem) {
      // No tab in URL and no active item - set default first tab
      this.props.menuItemClick(settingsMenuItems.ACCOUNT_DETAILS);
    }
  }

  getSettingView() {
    switch (this.props.activeItem) {
      case settingsMenuItems.ACCOUNT_DETAILS:
        return (
          <AccountDetails
            onCancel={this.onCancel}
            goToPagesList={this.goToPagesList}
          />
        );
      case settingsMenuItems.UPDATE_PASSWORD:
        return (
          <div>
            <UpdatePassword
              onCancel={this.onCancel}
              goToPagesList={this.goToPagesList}
            />
          </div>
        );
      case settingsMenuItems.ACCOUNT_SECURITY:
        return (
          <div>
            <Security
              onCancel={this.onCancel}
              goToPagesList={this.goToPagesList}
            />
          </div>
        );
      case settingsMenuItems.EMAIL_NOTIFICATIONS:
        return (
          <EmailNotifications
            onCancel={this.onCancel}
            goToPagesList={this.goToPagesList} />
        );
      case settingsMenuItems.EYES_ONLY:
        return (
          <EyesOnly
            onCancel={this.onCancel}
            goToPagesList={this.goToPagesList}
          />
        );
      default:
        return null;
    }
  }

  goToPagesList = () => {
    const returnUrl = NavigationStateManager.consumeReturnUrl();
    if (returnUrl) {
      this.props.history.push(returnUrl);
    } else {
      // Default behavior for Settings sidebar navigation
      if (!this.props.isCampaignAdmin && !this.props.isEventAdmin) {
        this.props.history.push(
          `/accounts/${this.props.isSystemAdmin ? 'all' : 'admins'}`
        );
      }
    }
  };

  onCancel = () => {
    this.goToPagesList();
  };

  render() {
    return (
      <BasePageView
        isLoading={this.props.isLoading}
        isLoadingError={this.props.isLoadingError}
        backLink={`/accounts/admins`}
        backLinkTitle="Back to accounts"
      >
        <h1>
          <Translate value={i18nKeys.ACCOUNT_SETTINGS_TITLE} />
        </h1>
        <Grid>
          <GridRow>
            <GridColumn width={5}>
              <VerticalMenu />
            </GridColumn>
            <GridColumn width={11}>{this.getSettingView()}</GridColumn>
          </GridRow>
        </Grid>
      </BasePageView>
    );
  }
}

const mapState = ({ accountSettings, session }) => {
  const isSystemAdmin = get(session, 'isSystemAdmin');
  const isEventAdmin = get(session, 'isEventAdmin');

  return {
    isLoading: Record.isRecordLoading(accountSettings.record),
    isLoadingError: Record.isRecordLoadingError(accountSettings.record),
    activeItem: accountSettings.activeItem,
    accountData: accountSettings.record.data.data,
    isSystemAdmin,
    isEventAdmin
  };
};

const mapDispatch = (dispatch) => {
  return bindActionCreators(accountSettingsActions, dispatch);
};

const titleResolver = (props) => {
  const email = get(props, 'accountData.email', '');
  const tab = get(props, 'match.params.tab', get(props, 'activeItem', ''));
  const capitalizedTab = capitalizeCamelCase(tab);
  return I18n.t('page-titles.accounts.edit', { email, tab: capitalizedTab });
};

const AccountSettingsPageWithTitle = withPageTitle(titleResolver)(AccountSettingsPage);

const AccountSettingsPageContainer = withRouterV6(
  clear(connect(mapState, mapDispatch)(AccountSettingsPageWithTitle))
);
export default AccountSettingsPageContainer;
